import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ITableColumn } from 'src/app/models/mat-simple-table/mat-simple-table.model';
import { MyCustomPaginatorIntl } from 'src/app/shared/providers/mat-paginator-intl';

@Component({
  selector: 'app-mat-simple-table',
  templateUrl: './mat-simple-table.component.html',
  styleUrls: ['./mat-simple-table.component.scss'],
  providers: [{ provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl }],
})
export class MatSimpleTableComponent<T> implements OnInit {
    private readonly COLUMNA_ACCIONES = 'actions';

    @Input() columns: ITableColumn[] = [];
    @Input() data: T[] = [];

    @Input() showEditButton?: boolean;
    @Input() showDeleteButton?: boolean;
    @Input() showConfigButton?: boolean;
    @Input() customAction?: string;

    @Input() isLoading = false;

    @Output() edit = new EventEmitter<T>();
    @Output() delete = new EventEmitter<T>();
    @Output() config = new EventEmitter<T>();
    @Output() executeCustomAction = new EventEmitter<T>();
    @Output() rowClicked = new EventEmitter<T>();

    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort

    public dataSource: MatTableDataSource<T> = new MatTableDataSource<T>();
    public displayedColumns: string[] = [];
    public printDisplayedColumns: string[] = [];

    ngOnInit(): void {
        this.displayedColumns = this.columns
            .filter(column => (column.visible ?? true) && column.attributeName)
            .map(column => column.attributeName);

        if (this.displayedColumns.length === 0) {
            throw new Error('No se han proporcionado columnas visibles para la tabla.');
        }

        this.printDisplayedColumns = [...this.displayedColumns];

        if (this.showEditButton || this.showDeleteButton || this.showConfigButton || this.customAction) {
            this.displayedColumns.push(this.COLUMNA_ACCIONES);
        }

        this.dataSource.data = this.data;
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['data'] && this.dataSource) {
        this.dataSource.data = this.data || [];
        }
    }

    onEdit(element: T): void {
        this.edit.emit(element);
    }

    onDelete(element: T): void {
        this.delete.emit(element);
    }

    onConfig(element: T): void {
        this.config.emit(element);
    }

    onExecuteCustomAction(element: T): void {
        this.executeCustomAction.emit(element);
    }

    onRowClicked(element: T): void {
        this.rowClicked.emit(element);
    }
}
